import type { Subscription } from '../../types';
import { isSelfServe as isModernSubscriptionSelfServe } from '../modernSubscription/isSelfServe';

import { isModernSubscription } from './isModernSubscription';

export function isSelfServe(subscription: Subscription) {
  if (isModernSubscription(subscription)) {
    return isModernSubscriptionSelfServe(subscription);
  }

  // not supported on legacy subscriptions
  return false;
}
